import { useUserStore } from 'Store/userStore'

async function responseErrorStatusInterceptor(error) {
  if (!error.response) {
    return Promise.reject(error)
  }

  const userStore = useUserStore()

  // all the other error responses
  switch (error.response.status) {
    //To-Do: Do we need to hanlde any 3XX responses?
    //To-Do: Do we need to hanldle 402, 421, 422, 423, 424, 425, 451?
    //To-Do: Do we need to hanlde 505, 506, 507, 508, 510, 511?
    //To-Do: Is the switch statement below too granular? Should we handle certain response codes the same exact way?
    case 400:
      console.error(error.response.status, error.message)
      break
    case 401: // authentication error
      // if token authentication fails log the user out
      await userStore.logout()
      break
    case 403:
      //To-Do: Access forbidden What to do here? Redirect to access denied page?
      console.error(error.response.status, error.message)
      break
    case 404:
      //To-Do: Not found what to do here? Redirect to 404 page?
      console.error(error.response.status, error.message)
      break
    case 405:
      //To-Do: Method not allowed, might be useful to create a handler in case we bring in ext api's
      console.error(error.response.status, error.message)
      break
    case 406:
      //To-Do: Not-Acceptable, mihgt be useful to create hanlder in case we bring in ext api's
      console.error(error.response.status, error.message)
      break
    case 407:
      //To-Do: Proxy Authentication required - might be needed depending on auth method
      console.error(error.response.status, error.message)
      break
    case 408:
      //To-Do: Request timeout - How do we want to handle timeouts? Should we handle them after retries?
      console.error(error.response.status, error.message)
      break
    case 409:
      //To-do: Conflict, How do we want to handle?
      console.error(error.response.status, error.message)
      break
    case 410:
      //To-do: Gone - Might be useful if integrating with external api
      console.error(error.response.status, error.message)
      break
    case 411:
      //To-do: Length Requires - Might be useful if integrating with external api
      console.error(error.response.status, error.message)
      break
    case 412:
      //To-do: Precondition Failed
      console.error(error.response.status, error.message)
      break
    case 413:
      //To-do: Payload too large
      console.error(error.response.status, error.message)
      break
    case 414:
      //To-do: URI too long
      console.error(error.response.status, error.message)
      break
    case 415:
      //To-do: Unsupported media type
      console.error(error.response.status, error.message)
      break
    case 416:
      //To-do: Range Not Satisfiable
      console.error(error.response.status, error.message)
      break
    case 417:
      //To-do expectation failed
      console.error(error.response.status, error.message)
      break
    case 425:
      //To-do Too early
      console.error(error.response.status, error.message)
      break
    case 426:
      //To-do Upgrade required
      console.error(error.response.status, error.message)
      break
    case 428:
      //To-do Precondition required
      console.error(error.response.status, error.message)
      break
    case 429:
      //To-do too many request
      console.error(error.response.status, error.message)
      break
    case 431:
      //To-do request header fields too large
      console.error(error.response.status, error.message)
      break
    case 500:
      //To-do Internal Server error
      console.error(error.response.status, error.message)
      break
    case 501:
      //To-do Not implemented
      console.error(error.response.status, error.message)
      break
    case 502:
      //To-do Bad Gateway
      console.error(error.response.status, error.message)
      break
    case 503:
      //To-do Service unavailable
      console.error(error.response.status, error.message)
      break
    case 504:
      //To-do Gateway timeout
      console.error(error.response.status, error.message)
      break
    default:
      console.error(error.response.status, error.message)
  }
  return Promise.reject(error)
}

export { responseErrorStatusInterceptor }
